import { useCurrentMember } from '@globals/useCurrentMember'
import usePaginatedDraftRecognitions from './usePaginatedDraftRecognitions'

const useInProgressRecognitions = () => {
  const { member } = useCurrentMember()

  const {
    fetchMoreRecognitions,
    hasMoreRecognitions,
    isFetchingNextPage,
    isLoading,
    isRefetching,
    recognitionsData,
    refetch: refetchDraftRecognitions,
  } = usePaginatedDraftRecognitions({ enabled: !!member?.id })

  return {
    fetchMoreRecognitions,
    hasMoreRecognitions,
    isFetchingNextPage,
    isLoading,
    isRefetching,
    recognitionsData,
    refetchDraftRecognitions,
  }
}

export default useInProgressRecognitions
